export const propertyProfilePrices = state => state.propertyProfilePrices;
export const propertyProfilePrice = state => state.propertyProfilePrice;
export const updateProfilePriceSuccess = state => state.updateProfilePriceSuccess;
export const updateProfilePriceError = state => state.updateProfilePriceError;
